import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { postExportColumns } from '../../config/exportColumns/postExportColumns'
import { useState } from 'react'
import { appGetAllPost } from '../../store/post'

function Post() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const [exportFilters, setExportFilters] = useState({})
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Posts</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllPost({
										...params,
										...exportFilters,
										limit: 10000,
										sanstha: sansthaId || permissionOfSanstha,
										loading: false,
									}),
								)
							}
							columns={postExportColumns}
							fileName="Posts"
							sheetName="Post List"
							buttonText="Export Posts"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/post/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Post
						</button>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Post
